import { IResponseAdminWalletBalance } from '@/core/domain/entities/user';

interface IManageWalletBalanceViewProps {
  adminWalletInfo: IResponseAdminWalletBalance;
  onClickRefreshAdminWalletBtn: () => void;
}

const ManageWalletBalanceView = ({ adminWalletInfo, onClickRefreshAdminWalletBtn }: IManageWalletBalanceViewProps) => {
  const walletAddress = adminWalletInfo.address;
  const solBalance = adminWalletInfo.balance;
  // 소수점 6자리까지 표시하고 나머지 버림 처리
  const formattedSolBalance = solBalance ? (Math.floor(Number(solBalance) * 1000000) / 1000000).toFixed(6) : '0.000000';

  const handleCopyAddress = () => {
    navigator.clipboard.writeText(walletAddress);
    alert('주소가 복사되었습니다.');
  };

  return (
    <div className="asset-content setting-container">
      <div className="asset-manage-card">
        <div className="asset-manage-address-row">
          <span className="asset-manage-address text-xs font-medium">{walletAddress}</span>
          <button type="button" className="asset-manage-copy-btn" onClick={handleCopyAddress}>
            <img src="./images/copy-icon.png" alt="복사" className="asset-manage-copy-icon" />
          </button>
        </div>

        <div className="asset-manage-balance-row">
          <span className="asset-manage-balance-amount heading-2 font-semibold">{formattedSolBalance}</span>
          <span className="asset-manage-balance-unit heading-3 font-medium">SOL</span>
          <button type="button" className="asset-manage-refresh-btn" onClick={onClickRefreshAdminWalletBtn}>
            <img src="./images/refresh-icon.png" alt="새로고침" className="asset-manage-refresh-icon" />
          </button>
        </div>

        <div className="asset-manage-notice">
          <p className="asset-manage-notice-text text-sm font-normal">
            ※ 이 관리지갑에 0.1 SOL 이상이 충전되어 있어야<br />신규 회원 가입이 가능합니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ManageWalletBalanceView;
